export default __webpack_public_path__ + "1d7232cb935bf3f41660385cdae3d376.png";